<template>
  <side-bar v-show="isSidebarActiveLocal" position-right class="z-10 max-w25">
    <div
      class="flex  sidebar-topfixpart bg-primary justify-between p-4 add-sidebar-top"
    >
      <h2 class="h2-class font-semibold text-white ">
        Customer
      </h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="px-4 pt-20 pb-12 mt-16">
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Name</p>
        <b-input placeholder="Enter Name..." />
      </div>
      <!-- <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Store Shop Name</p>
        <b-input placeholder="Enter  Name..." />
      </div> -->

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Mobile</p>
        <b-input placeholder="Enter  Mobile..." />
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Email ID</p>
        <b-input placeholder="Enter  EmailID..." />
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Address</p>
        <b-input placeholder="Enter Address..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Address 2</p>
        <b-input placeholder="Enter Address..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Address 3</p>
        <b-input placeholder="Enter Address..." />
      </div>

      <!-- <div class="mb-4 flex">
        <div class="pr-2 w-1/2">
          <p class="font-semibold text-sm mb-2">City</p>

          <b-input placeholder="Enter  City..." />
        </div>

        <div class="pl-2 w-1/2">
          <p class="font-semibold text-sm mb-2">State</p>

          <b-input placeholder="Enter  State..." />
        </div>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Pin Code</p>
        <b-input placeholder="Enter  pincode..." />
      </div> -->
    </div>
    <footer class="footer-fix fixed bottom-0	w-1/4 ">
      <base-button
        block
        type="primary"
        class="uppercase rounded-none font-semibold"
        >ADD</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {};
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  }
};
</script>
